var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0419 0H5.95811C2.67279 0 0 2.67279 0 5.95811V14.0419C0 17.3272 2.67279 20 5.95811 20H14.0419C17.3272 20 20 17.3272 20 14.0419V5.95811C20 2.67279 17.3272 0 14.0419 0ZM17.988 14.0419C17.988 16.2212 16.2212 17.988 14.0419 17.988H5.95811C3.77875 17.988 2.012 16.2212 2.012 14.0419V5.95811C2.012 3.77871 3.77875 2.012 5.95811 2.012H14.0419C16.2212 2.012 17.988 3.77871 17.988 5.95811V14.0419Z",
    fill: "#3d5e69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17271 0C2.32047 0 0 2.32047 0 5.17267C0 8.02488 2.32047 10.3454 5.17271 10.3454C8.02495 10.3454 10.3454 8.02491 10.3454 5.17267C10.3454 2.32044 8.02495 0 5.17271 0ZM5.17271 8.33342C3.42708 8.33342 2.012 6.91834 2.012 5.17271C2.012 3.42708 3.42712 2.012 5.17271 2.012C6.91834 2.012 8.33343 3.42708 8.33343 5.17271C8.33343 6.9183 6.9183 8.33342 5.17271 8.33342Z",
    transform: "translate(4.828 4.82812)",
    fill: "#3d5e69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23949 2.47898C1.92404 2.47898 2.47898 1.92404 2.47898 1.23949C2.47898 0.554938 1.92404 0 1.23949 0C0.554938 0 0 0.554938 0 1.23949C0 1.92404 0.554938 2.47898 1.23949 2.47898Z",
    transform: "translate(13.9432 3.62695)",
    fill: "#3d5e69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.37c7cdb909b8768cf93e025f7bbebab9.svg";
export { ForwardRef as ReactComponent };